<div class=''>
  <div class='main_wrapper'>
    <frontend-verify-header-admin (eventCurrentUser)='getCurrentUser($event)'></frontend-verify-header-admin>
    <frontend-side-bar-admin></frontend-side-bar-admin>
    <section class='main_content'>
      <div class='main_sec'>
        <div class='sec_content'>
          <div class='distribute-token position-relative'>
            <div class='container-fluid'>
              <div class='row'>
                <div class='col-12 p-0'>
                  <div class='back_btn' (click)='redirectBack()'>
                    <a><img src='assets/images/back_ic.svg' />{{ 'back' | translate }}</a>
                  </div>
                  <div class='d-flex align-items-center justify-content-between mt-3'>
                    <h1 class='fs-32 title'> {{ 'Contents' | translate }}</h1>
                  </div>

                  <div class='tab-content mt-3'>
                    <div class='tab-pane fade show active' id='payout' role='tabpanel' aria-labelledby='payout-tab'>
                      <div class='distribute-token-list'>
                        <div class='container-fluid'>
                          <form [formGroup]='filter'>
                            <div class='row my-2 my-md-4'>
                              <div class='px-0 px-md-2 mb-1 mb-md-0 col-md-3'>
                                <div class='form-group'>
                                  <div class='left-header d-md-block'>
                                    <div class='form-group mb-0'>
                                      <div class='position-relative'>
                                        <img src='assets/images/search_tab.png' class='search-icon status-search'
                                             alt='' />
                                        <input type='search' class='form-control br-16 search-input'
                                               placeholder="{{'search artist name' | translate}}"
                                               (keyup)='search($event)'>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class='px-0 px-md-2 mb-1 mb-md-0 col-md-3'>
                                <div class='form-group'>
                                  <label class='form-label fs-12 m-0'>{{ 'date_range' | translate }}</label>
                                  <frontend-custom-select
                                    class='filter-wallet-data'
                                    [searchable]='true'
                                    [placeholder]="('select_date' | translate)"
                                    [selectOptions]='month'
                                    selectedValue='monthRange'
                                    (optionSelected)='filterMonthRangeData()'
                                    [formGroup]='filter'>
                                  </frontend-custom-select>
                                </div>
                              </div>
                              <div class='px-0 px-md-2 mb-1 mb-md-0 col-md-3'>
                                <div class='form-group'>
                                  <label class='form-label fs-12 m-0'>{{ 'Content Type' | translate }}</label>
                                  <frontend-custom-select
                                    class='filter-wallet-data'
                                    [searchable]='true'
                                    [placeholder]="('select_type' | translate)"
                                    [selectOptions]='content_types'
                                    selectedValue='content_type'
                                    (optionSelected)='filterContentTypeData()'
                                    [formGroup]='filter'>
                                  </frontend-custom-select>
                                </div>
                              </div>
                              <div class='px-0 px-md-2 mb-1 mb-md-0 col-md-3'>
                                <div class='form-group'>
                                  <label class='form-label fs-12 m-0'>{{ 'Status' | translate }}</label>
                                  <frontend-custom-select
                                    class='filter-wallet-data'
                                    [searchable]='true'
                                    [placeholder]="('Select Status' | translate)"
                                    [selectOptions]='statusOptions'
                                    selectedValue='status'
                                    (optionSelected)='filterStatusData()'
                                    [formGroup]='filter'>
                                  </frontend-custom-select>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div class='container-fluid'>
                          <div class='row'>
                            <div class='finance-table px-0 mb-4'>
                              <div class='custom-table finances-table'>
                                <frontend-custom-table
                                  #customTableComponent
                                  [customOptions]='customDatatableSettings'
                                  [tableHead]='tableHead'
                                  [ajaxFunction]='getAllTransaction'
                                  [tableBody]='tableBody'>
                                </frontend-custom-table>
                                <ng-template #tableHead>
                                  <thead>
                                  <tr>
                                    <td>
                                      <p
                                        class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'Creator Name' | translate }}
                                      </p>
                                    </td>
                                    <td>
                                      <p
                                        class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'Author' | translate }}
                                      </p>
                                    </td>
                                    <td>
                                      <p *ngIf="filter.value.content_type==='video'"
                                         class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'Views' | translate }}
                                      </p>
                                      <p *ngIf="filter.value.content_type==='podcast_episode'"
                                         class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'Podcast' | translate }}
                                      </p>
                                      <p *ngIf="filter.value.content_type==='track'"
                                         class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'Album' | translate }}
                                      </p>
                                    </td>
                                    <td>
                                      <p
                                        class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'Streams' | translate }}
                                      </p>
                                    </td>
                                    <td>
                                      <p
                                        class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'CreatedAt' | translate }}
                                      </p>
                                    </td>
                                    <td>
                                      <p
                                        class='title d-flex align-items-center position-relative mb-0 fs-14 fw-bold store-content-details'>
                                        {{ 'Status' | translate }}
                                      </p>
                                    </td>
                                  </tr>
                                  </thead>
                                </ng-template>
                                <ng-template #tableBody>
                                  <tbody *ngIf='contents.length <= 0'>
                                  <tr>
                                    <td colspan='4'>{{ 'no_data_found' | translate }}</td>
                                  </tr>
                                  </tbody>
                                  <tbody *ngIf='contents.length > 0'>
                                  <tr *ngFor='let content of contents'>
                                    <td>
                                      <p class='mb-0 fs-16 store-content-details text-truncate'>
                                        <img [src]="content.thumbnail || content.image || 'assets/images/store.png'" />
                                        {{ content?.title }}
                                      </p>
                                    </td>
                                    <td
                                      *ngIf="filter.value.content_type==='video' || filter.value.content_type==='track'"
                                      tooltip='{{content?.author?.full_name}}'>
                                      <p class='mb-0 fs-16 store-content-details text-truncate'>
                                        <img [src]="content?.author?.photo || 'assets/images/store.png'" />
                                        {{ content?.author?.full_name }}
                                      </p>
                                    </td>
                                    <td *ngIf="filter.value.content_type==='podcast_episode'">
                                      <p class='mb-0 fs-16 store-content-details text-truncate'>
                                        <img [src]="content?.podcast?.thumbnail || 'assets/images/store.png'" />
                                        {{ content?.podcast?.title }}
                                      </p>
                                    </td>
                                    <td *ngIf="filter.value.content_type==='podcast_episode'">
                                      <p class='mb-0 fs-16 store-content-details'>
                                        <img
                                          [src]="content?.podcast?.uploader?.thumbnail || 'assets/images/store.png'" />
                                        {{ content?.podcast?.uploader?.full_name }}
                                      </p>
                                    </td>
                                    <td *ngIf="filter.value.content_type==='track'">
                                      <p class='mb-0 fs-16 store-content-details text-truncate'>
                                        <img [src]="content?.album?.photo || 'assets/images/store.png'" />
                                        {{ content?.album?.title }}
                                      </p>
                                    </td>
                                    <td *ngIf="filter.value.content_type==='video'">
                                      <p class='mb-0 fs-16 store-content-details'>
                                        {{ content?.views }}
                                      </p>
                                    </td>
                                    <td>
                                      <p class='mb-0 fs-16 store-content-details'>
                                        {{ content?.streams }}
                                      </p>
                                    </td>
                                    <td>
                                      <p class='mb-0 fs-16 store-content-details'>
                                        {{ content?.createdAt | date: 'dd/MM/yyyy' }}
                                      </p>
                                    </td>
                                    <td>
                                      <div class='toggle_btn d-flex align-items-center gap-2'>
                                        <input type='checkbox' id='switch' [checked]='content?.is_active' />
                                        <label class='switch' (click)='updateStatus(content?._id, !content?.is_active)'>Toggle</label>
                                      </div>
                                    </td>
                                  </tr>
                                  </tbody>
                                </ng-template>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <frontend-bottom-header-admin></frontend-bottom-header-admin>
  </div>
</div>
